import { Routes } from '@angular/router';
import { SampleComponent } from './pages/sample/sample/sample.component';
import { RegisterComponent } from './pages/login/register/register.component';
import { ExceptionsDetailComponent } from './pages/exceptions/exceptions-detail/exceptions-detail.component';
import { ExceptionsCreateComponent } from './pages/exceptions/exceptions-create/exceptions-create.component';
import { VehiclesListComponent } from './pages/vehicles/vehicles-list/vehicles-list.component';
import { VehiclesDetailComponent } from './pages/vehicles/vehicles-detail/vehicles-detail.component';
import { VehiclesCreateComponent } from './pages/vehicles/vehicles-create/vehicles-create.component';
import { FaqComponent } from './pages/faq/faq.component';
import { ZbeComponent } from './pages/zbe/zbe.component';
import { VehicleCheckComponent } from './pages/vehicles/vehicle-check/vehicle-check.component';
import { ProfileComponent } from './pages/account/profile/profile.component';
import { SettingsComponent } from './pages/account/settings/settings.component';
import { canActivateAdmin, canActivateAuth } from './guards/auth.guard';
import { TagsComponent } from './pages/zbe/tags/tags.component';
import { AutorizationTypesComponent } from './pages/autorizations/autorization-types/autorization-types.component';

import { LoginPrivateComponent } from './pages/login/login-private/login-private.component';
import { VehiclesEditComponent } from './pages/vehicles/vehicles-edit/vehicles-edit.component';
import { ComunicationsComponent } from './pages/account/comunications/comunications.component';
import { ComunicationsDetailComponent } from './pages/account/comunications-detail/comunications-detail.component';
import { AccessPageComponent } from './pages/access-page/access-page.component';
import { ConditionsComponent } from './pages/legal/conditions/conditions.component';
import { DataProtectionComponent } from './pages/legal/data-protection/data-protection.component';
import { AutorizationDetailComponent } from './pages/autorizations/autorization-detail/autorization-detail.component';
import { LoginRedirectComponent } from './pages/login/login-redirect/login-redirect.component';
import { LoginLocalComponent } from './pages/login/login-local/login-local.component';
import { LoginRedirectPrivateComponent } from './pages/login/login-redirect-private/login-redirect-private.component';
import { CookiesPageComponent } from './pages/cookies-page/cookies-page.component';
import { AccesibleComponent } from './pages/accesible/accesible.component';
import { RegisterForeignComponent } from './pages/login/register-foreign/register-foreign.component';
import { PrivacyComponent } from './pages/legal/privacy/privacy.component';
import { RecoverPassComponent } from './pages/login/recover-pass/recover-pass.component';
import { DataTreatmentComponent } from './pages/legal/data-treatment/data-treatment.component';
import { AyuntamientosComponent } from './pages/ayuntamientos/ayuntamientos.component';
import { MunicipiosComponent } from './pages/municipios/municipios.component';
import { PrivateAccessComponent } from './pages/private-access/private-access.component';
import { UsersComponent } from './pages/users/users.component';
import { TracesComponent } from './pages/traces/traces.component';
import { OperatorsDetailPageComponent } from './pages/operators/operators-detail-page/operators-detail-page.component';
import { OperatorsListPageComponent } from './pages/operators/operators-list-page/operators-list-page.component';
import { ContactPageComponent } from './pages/contact-page/contact-page.component';
import { ContactDetailComponent } from './pages/contacts/contact-detail/contact-detail.component';
import { MunicipyPageComponent } from './pages/zbe/municipy-page/municipy-page.component';

export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', loadComponent: () => import('@pages/home/home.component').then(c => c.HomeComponent) },
    { path: 'who', loadComponent: () => import('@pages/who/who.component').then(c => c.WhoComponent), data: { title: $localize`:@@Router.Who:¿Qué es una ZBE?` } },
    { path: 'login', loadComponent: () => import('@pages/login/login/login.component').then(c => c.LoginComponent), data: { title: $localize`:@@Router.Login:Área privada` } },
    { path: 'sample', component: SampleComponent, data: { title: $localize`:@@Router.Sample:Ejemplo` } },
    { path: 'recover-pass', component: RecoverPassComponent, data: { title: $localize`:@@Router.RecoverPass:Recuperar contraseña` } },
    { path: 'login-redirect', component: LoginRedirectComponent, data: { title: $localize`:@@Router.Login:Área privada` } },
    { path: 'login-redirect-private', component: LoginRedirectPrivateComponent, data: { title: $localize`:@@Router.Login:Área privada` } },
    { path: 'login-private', component: LoginPrivateComponent, data: { title: $localize`:@@Router.LoginP:Acceso operadores` } },
    { path: 'login-local', component: LoginLocalComponent, data: { title: $localize`:@@Router.LoginP:Acceso operadores` } },
    { path: 'register', component: RegisterComponent, data: { title: $localize`:@@Router.Register:Registro` } },
    { path: 'register-foreign', component: RegisterForeignComponent, data: { title: $localize`:@@Router.RegisterForeign:Registro extranjero` } },
    {
        path: 'autorizations',
        data: { title: $localize`:@@Router.Autorizations.Autorizations:Autorizaciones` },
        children: [
            { path: '', component: AutorizationTypesComponent },
            { path: ':code', component: AutorizationDetailComponent, data: { title: $localize`:@@Router.Autorizations.Detail:Detalle` } }
        ]
    },
    { path: 'vehicles-check', component: VehicleCheckComponent, data: { title: $localize`:@@Router.VehCheck:Vehículos afectados` } },
    { path: 'faq', component: FaqComponent, data: { title: $localize`:@@Router.FAQ:Preguntas frecuentes` } },
    { path: 'zbe/tags', component: TagsComponent, data: { title: $localize`:@@Router.Tags:Etiquetas` } },
    { 
        path: 'zbe',
        data: { title: $localize`:@@Router.ZBE:ZBE actuales` },
        children: [
            { path: '', component: ZbeComponent },
            { path: ':code', component: MunicipyPageComponent, data: { title: $localize`:@@Router.Municipy:Municipio` } }
        ]
    },
    { path: 'contact', component: ContactPageComponent, data: { title: $localize`:@@Router.Public.Contact:Contacto` } },
    {
        path: 'access',
        canActivate: [canActivateAuth],
        data: { title: $localize`:@@Router.Access:Mis accesos` },
        children: [
            { path: '', component: AccessPageComponent },
            { path: 'new/:redirect', component: VehiclesCreateComponent, data: { title: $localize`:@@Router.VehDetail.New:Nuevo vehículo` } },
        ]
    },
    {
        path: 'exceptions',
        canActivate: [canActivateAuth],
        data: { title: $localize`:@@Router.Vehicles:Vehículos` },
        children: [
            { path: '', component: VehiclesListComponent },
            { path: ':plate/new', component: ExceptionsCreateComponent, data: { title: $localize`:@@Router.Exceptions.New:Nueva autorización` } },
            { path: ':plate/new/:code', component: ExceptionsCreateComponent, data: { title: $localize`:@@Router.Exceptions.New:Nueva autorización` } }
        ]
    },
    {
        path: 'vehicles',
        canActivate: [canActivateAuth],
        data: { title: $localize`:@@Router.Vehicles.MyVehicles:Mis autorizaciones` },
        children: [
            { path: '', component: VehiclesListComponent },
            { path: 'new', component: VehiclesCreateComponent, data: { title: $localize`:@@Router.VehDetail.New:Nuevo vehículo` } },
            {
                path: ':plate',
                data: { title: $localize`:@@Router.VehDetail.Detail:Detalle` },
                children: [
                    { path: '', component: VehiclesDetailComponent },
                    { path: 'edit', component: VehiclesEditComponent, data: { title: $localize`:@@Router.VehEdit.Edit:Editar` } },
                    { path: 'exceptions/:id', component: ExceptionsDetailComponent, data: { title: $localize`:@@Router.VehExcep:Excepción` } }
                ]
            },
        ]
    },
    { path: 'profile', component: ProfileComponent, canActivate: [canActivateAuth], data: { title: $localize`:@@Router.Profile:Mi perfil` } },
    { path: 'settings', component: SettingsComponent, canActivate: [canActivateAuth], data: { title: $localize`:@@Router.Settings:Ajustes` } },
    {
        path: 'comunications',
        canActivate: [canActivateAuth],
        data: { title: $localize`:@@Router.Comunications.Comunications:Comunicaciones` },
        children: [
            { path: '', component: ComunicationsComponent },
            { path: ':id', component: ComunicationsDetailComponent, data: { title: $localize`:@@Router.Comunications.Detail:Detalle` } }
        ]
    },
    { path: 'use-conditions', component: ConditionsComponent, data: { title: $localize`:@@Router.Conditions:Condiciones de uso` } },
    { path: 'data-protection', component: DataProtectionComponent, data: { title: $localize`:@@Router.DataProtection:Protección de datos` } },
    { path: 'data-treatment', component: DataTreatmentComponent, data: { title: $localize`:@@Router.DataTreatment:Tratamiento de datos` } },
    { path: 'privacy', component: PrivacyComponent, data: { title: $localize`:@@Router.Privacy:Pólitica de privacidad` } },
    { path: 'cookies', component: CookiesPageComponent, data: { title: $localize`:@@Router.Cookies:Política de cookies` } },
    { path: 'town-halls', component: AyuntamientosComponent, data: { title: $localize`:@@Router.Ayuntamientos:Ayuntamientos` } },
    { path: 'municipalities', component: MunicipiosComponent, data: { title: $localize`:@@Router.Municipios:Municipios` } },
    { path: 'accesible', component: AccesibleComponent, data: { title: $localize`:@@Router.Accesible:Accesibilidad` } },
    {
        path: 'requests',
        canActivate: [canActivateAdmin],
        data: { title: $localize`:@@Router.Requests.Requests:Solicitudes` },
        children: [
            { path: '', loadComponent: () => import('@pages/requests/request-list/request-list.component').then(c => c.RequestListComponent)},
            {path: ':applicant/:plate/:id', loadComponent: () => import('@pages/requests/request-detail/request-detail.component').then(c => c.RequestDetailComponent), data: { title: $localize`:@@Router.Requests.Detail:Detalle` } }
        ]
    },
    {
        path: 'signatures',
        canActivate: [canActivateAdmin],
        data: { title: $localize`:@@Router.Requests.Signatures:Signatures` },
        loadComponent: () => import('@pages/signatures/signatures.component').then(c => c.SignaturesComponent)
    },
    { path: 'private-access', component: PrivateAccessComponent, canActivate: [canActivateAdmin], data: { title: $localize`:@@Router.Private.Access:Accesos` } },
    { path: 'users', component: UsersComponent, canActivate: [canActivateAdmin], data: { title: $localize`:@@Router.Private.Users:Usuarios` } },
    {
        path: 'operators',
        canActivate: [canActivateAdmin],
        data: { title: $localize`:@@Router.Private.Operators:Operadores` },
        children: [
            { path: '', component: OperatorsListPageComponent },
            { path: ':id', component: OperatorsDetailPageComponent, data: { title: $localize`:@@Router.Private.OperatorsDetail:Detalle` } }
        ]
    },
    { path: 'traces', component: TracesComponent, canActivate: [canActivateAdmin], data: { title: $localize`:@@Router.Private.Traces:Informe trazabilidad` } },
    {
        path: 'contacts',
        canActivate: [canActivateAdmin],
        data: { title: $localize`:@@Router.Private.Contacts:Contactos` },
        children: [
            { path: '', loadComponent: () => import('@pages/contacts/contact-list/contact-list.component').then((c) => c.ContactListComponent)  },
            { path: ':id', component: ContactDetailComponent, data: { title: $localize`:@@Router.Private.ContactsDetail:Detalle` } }
        ]
    },
    { path: '**', redirectTo: 'home' }
];
